import { useMatch, useResolvedPath } from 'react-router-dom'

/**
 * Checks if a route key is part of the current browser pathname.
 *
 * @param {string} key - The route segment to match.
 * @returns {boolean} "page" | false if the key is part of the current URL pathname.
 */

export const isMenuActive = (key: string = ''): 'page' | false => {
  const path = useResolvedPath(key)
  const isCurrentPage = useMatch(path.pathname)
  if (!key || !isCurrentPage) return false
  return 'page'
}
